{
  "version": 1,
  "asset_id": "fc653655-6e7e-4ab8-bff6-de0b7c0542ad",
  "project_id": "ede4779f-2e7a-461a-91d6-654024119c69",
  "url": "/__l5e/assets-v1/fc653655-6e7e-4ab8-bff6-de0b7c0542ad/iwona-borawska.jpg",
  "r2_key": "a/v1/ede4779f-2e7a-461a-91d6-654024119c69/fc653655-6e7e-4ab8-bff6-de0b7c0542ad/iwona-borawska.jpg",
  "original_filename": "iwona-borawska.jpg",
  "size": 65633,
  "content_type": "image/jpeg",
  "created_at": "2026-09-14T17:14:48Z"
}
